export const START = 'START'
export const PAUSE = 'PAUSE'
export const STOP = 'STOP'
export const TOGGLE_SOUND = 'TOGGLE_SOUND'




// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js